import { useMemo } from 'react';
import { Text } from '@mercator-gcp/grout';
import CollectionDetailsBasic from 'components/widgets/Dashboard/PinnedProjects/CollectionDetailsBasic';
import { DEFAULT_COLLECTIONS } from 'components/widgets/Dashboard/PinnedProjects/constants';
import { useHiddenProjects } from 'hooks/useHiddenProjects';
import { usePaginate } from 'hooks/usePaginate';
import { useSortedProjects } from 'hooks/useSortedProjects';

const HiddenProjectsDetails = () => {
  const { getPaginatedHiddenProjectsForUser, getAllHiddenProjectIdsForUser } =
    useHiddenProjects();
  const { page: currentPage } = usePaginate();
  const { sortArray } = useSortedProjects();
  const { data: hiddenProjectList, isLoading: isLoadingHiddenProjects } =
    getPaginatedHiddenProjectsForUser({ pageNumber: currentPage, sort: sortArray });

  const { data: hiddenProjectsSet } = getAllHiddenProjectIdsForUser;

  const filteredList = useMemo(() => {
    if (!hiddenProjectsSet || !hiddenProjectList) {
      return [];
    }

    return hiddenProjectList?.results;
  }, [hiddenProjectList, hiddenProjectsSet]);

  return (
    <CollectionDetailsBasic
      collectionName={DEFAULT_COLLECTIONS.ALL_HIDDEN.label}
      collectionItems={filteredList}
      totalProjectCount={hiddenProjectsSet?.size || 0}
      isLoading={isLoadingHiddenProjects}
      emptyPlaceholder={<Text>No &ldquo;Pass&rdquo; projects</Text>}
    />
  );
};

export default HiddenProjectsDetails;
